var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrainingAtlasOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#training-atlas-outline_svg__clip0_785_8470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.483 1.921L.22 6.261l-.4-1.96 21.263-4.34.4 1.96zM16.16 15.2h.8a.8.8 0 010 1.6h-.8v2.4a.8.8 0 01-.8.8h-.8a.8.8 0 01-.8-.8v-2.4h-4v2.4a.8.8 0 01-.8.8h-.8a.8.8 0 01-.8-.8v-2.4h-.8a.8.8 0 010-1.6h.8v-2.4a.8.8 0 01.8-.8h.8a.8.8 0 01.8.8v2.4h4v-2.4a.8.8 0 01.8-.8h.8a.8.8 0 01.8.8v2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.8 9a1 1 0 011-1h20a1 1 0 011 1v14a1 1 0 01-1 1h-20a1 1 0 01-1-1V9zm2 1v12h18V10h-18z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "training-atlas-outline_svg__clip0_785_8470"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgTrainingAtlasOutline;